import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart2,
  Calendar,
  Flag,
  GoalPlans,
  Heart,
  Image,
  Repeat,
  Roadmap,
  Target,
  TodoList2,
} from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { premiumUsps } from 'shared/constants/premium-usps';

import * as Styled from './feature-list.style';

const uspIcons = [
  Target,
  Repeat,
  Calendar,
  Roadmap,
  GoalPlans,
  Flag,
  TodoList2,
  BarChart2,
  Heart,
  Image,
];

const features = premiumUsps.map(({ label }, index) => ({
  icon: uspIcons[index],
  labelKey: label,
}));

export const FeatureList: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.FeatureList>
      {features.map(({ icon, labelKey }) => (
        <Styled.FeatureItem key={labelKey}>
          <Styled.FeatureIcon>
            <Icon icon={icon} />
          </Styled.FeatureIcon>
          <Styled.FeatureLabel>{t(labelKey)}</Styled.FeatureLabel>
        </Styled.FeatureItem>
      ))}
    </Styled.FeatureList>
  );
};
